import { basePricingXrColumns } from './base-pricing-xr-columns';

export const opportunityXrColumns = [...basePricingXrColumns, 'opportunity_id', 'rule_id', 'rule_version_number'];
